export enum PageType {
  PAGE_FETCHED = 'PAGE_FETCHED',
  ERROR = 'ERROR',
}
